const prefix = 'nxt';
const iconName = 'phoneInbound';
const width = 1024;
const height = 1024;
const ligatures = [];
const unicode = '';
const svgPathData = [
  'M959.794 666.547l-200.329-84.445c-9.819-3.929-21.605-7.858-35.353-7.858-27.495 0-53.029 13.747-68.737 33.384l-64.808 78.563c-104.097-56.958-186.581-139.442-243.538-243.539l78.561-64.808c19.637-15.711 33.384-41.244 33.384-68.739 0-13.748-3.929-25.532-7.858-35.352l-84.448-200.326c-13.747-31.424-47.136-54.99-84.452-54.99-5.892 0-11.784 1.965-19.64 3.927l-184.615 41.244c-39.279 9.819-68.739 45.171-68.739 88.379 0 483.135 390.83 873.967 872.004 872.006 43.21 0 78.563-29.463 88.381-68.737l41.242-184.613c1.968-7.858 3.929-13.755 3.929-19.644 0-37.313-23.566-70.705-54.99-84.452zM877.301 931.683c-426.183-1.961-771.842-349.581-773.805-775.769l176.758-41.244 82.487 192.47-133.552 109.984c92.307 194.432 192.471 294.591 386.903 386.903l109.986-133.552 192.471 82.492-41.249 178.716z',
  'M866.959 300.071h-104.75l234.898-234.897c11.112-11.111 11.112-26.982 0-38.091l-19.048-19.044c-10.314-10.318-26.978-11.111-38.089 0l-234.898 234.895 0.798-103.957c0-14.285-12.698-26.982-26.985-26.982h-26.978c-14.285 0-26.985 12.698-26.985 26.982l0.798 215.056c-0.798 15.078 11.112 26.982 26.187 26.187l215.053 0.793c14.285 0 26.985-12.698 26.985-26.982v-26.982c0-14.284-12.698-26.982-26.985-26.982z',
];

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtPhoneInbound = definition;

export { definition, nxtPhoneInbound, prefix, iconName, width, height, ligatures, unicode, svgPathData };
